import { gql } from '@apollo/client';

const DELETE_ORG_UNIT_UNAVAILABLE_PERIOD = gql`
  mutation DeleteOrgUnitUnavailablePeriod($id: Int!) {
    deleteOrgUnitUnavailablePeriod(id: $id) {
      DeletedUnavailablePeriod
    }
  }
`;

export default DELETE_ORG_UNIT_UNAVAILABLE_PERIOD;
